import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '../../../node_modules/@angular/common/http';
import { Observable } from '../../../node_modules/rxjs';
import { ResponseContentType } from '@angular/http';
@Injectable()
export class FunctionService {

  constructor(private http: HttpClient) { }

  /**
   * Converte objeto para urlencode
   * @param data
   */
  public formatData(data) {
    
    return Object.keys(data).map(function(key){
      return encodeURIComponent(key) + '=' + encodeURIComponent(data[key]);
    }).join('&');
  }
  
  downloadLink(host:string){
    return this.http.get('https://cors-anywhere.herokuapp.com/'+host, {headers: new HttpHeaders({
          'Content-Type': 'application/json',
      }),observe: 'response' as 'body',
      responseType: 'blob' as 'blob' ,
    });
  }

  openPdf(host:string){
    this.downloadLink(host).subscribe(
        (res:any) =>{
          const fileURL = URL.createObjectURL(res.body);
          window.open(fileURL, '_blank');
        },err=>{
        }
    );
  }
}



// WEBPACK FOOTER //
// /var/www/minhaloga-cliente/src/app/provider/function.service.ts